import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { apiCall } from "services/api";

export const videoCallPermissionRequest = createAsyncThunk(
  "/videocall/request",
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await apiCall().post(
        "/videocall/permission/request",
        data
      );

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const videoCallPermissionGrant = createAsyncThunk(
  "/videocall/grant",
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await apiCall().post(
        "/videocall/permission/grant",
        data
      );

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
